module.exports = __webpack_public_path__ + "static/img/quality-bg.0695446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/quality-bg.png
// module id = kIE5
// module chunks = 1